import React, { FC } from "react";
import Modal from 'react-modal';
import CommandWizard from "../command/add/command-wizard";
import ShortcutWizard from "../shortcut/add/shortcut-wizard";

type Props = {
    onClose: () => void
    isOpen: boolean
    selectedIndex: number | undefined
};

const ControlPanelWizard: FC<Props> = ({ onClose, isOpen, selectedIndex }) => {

    const getWizard = () => {
        if (selectedIndex === 0) {
            return <CommandWizard
                onClose={onClose}
            />
        } else if (selectedIndex === 2) {
            return <ShortcutWizard
                onClose={onClose} />
        }
        return <></>
    }

    return <Modal
        isOpen={isOpen}
        ariaHideApp={false}
        overlayClassName="flex w-screen position-float fixed top-0 left-0 h-screen bg-opacity-75 bg-white"
        className="bg-white border-none m-auto shadow select-none outline-none w-content">
        {getWizard()}
    </Modal>
}

export default ControlPanelWizard